import { useEffect } from 'react';
import { trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2.ts';
import { type ButtonProps } from 'dibs-elements/exports/Button.tsx';
import { useServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext.tsx';

const PDP_BUTTON_STYLE_TEST = 'PDP_ButtonTest_March2026';

type Variant = 'variant' | 'variant-b';

type CustomColors = NonNullable<ButtonProps['customColors']>;

const VARIANT_1_COLORS: CustomColors = {
    background: 'sassyColorOrange600',
    hoverBackground: 'sassyColorOrange500',
    text: 'sassyColorWhite',
    disabledBackground: 'sassyColorDolphin',
    disabledText: 'sassyColorIron',
};

const VARIANT_2_COLORS: CustomColors = {
    background: 'sassyColorNoir',
    hoverBackground: 'sassyColorCharcoal',
    text: 'sassyColorWhite',
    disabledBackground: 'sassyColorDolphin',
    disabledText: 'sassyColorIron',
};

const getColorsForVariant = (variant?: Variant): CustomColors | undefined => {
    if (variant === 'variant') return VARIANT_1_COLORS;
    if (variant === 'variant-b') return VARIANT_2_COLORS;
    return undefined;
};

export const usePdpButtonAbTest = (): {
    isActive: boolean;
    colors: CustomColors | undefined;
} => {
    const { pdpButtonStyleVariant } = useServerVarsContext();
    return {
        isActive: !!pdpButtonStyleVariant,
        colors: getColorsForVariant(pdpButtonStyleVariant),
    };
};

export const useTrackPdpButtonStyleTest = (): void => {
    useEffect(() => {
        trackAbTestV2Variant(PDP_BUTTON_STYLE_TEST);
    }, []);
};
